var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "isso-root" } },
    [
      _c(
        "div",
        { ref: "container", staticClass: "container" },
        _vm._l(_vm.comment, function(com) {
          return _c(
            "div",
            { key: com.id, staticClass: "comment-root" },
            [
              _c("IssoComment", {
                attrs: {
                  author: com.author,
                  created: com.created,
                  text: com.text
                },
                on: { newcom: _vm.newCom, submit: _vm.submit_comment }
              })
            ],
            1
          )
        }),
        0
      ),
      _c("IssoInput", {
        attrs: { parent: null, error: _vm.submit_error },
        on: { submit: _vm.submit_comment }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }